// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'umbrella';

export const Component = () => (
  <path d='M20.35 4.065C18.145 2.005 15.463 1 12.302 1 9.143 1 6.46 2.005 4.305 4.065 2.102 6.125 1 8.71 1 11.775h10.823v9.819c0 .526-.191 1.005-.575 1.389a1.917 1.917 0 0 1-1.389.575 1.918 1.918 0 0 1-1.389-.575 1.917 1.917 0 0 1-.575-1.39H6.89c0 .815.287 1.534.91 2.108.575.575 1.245.861 2.06.861.813 0 1.484-.287 2.059-.861a2.89 2.89 0 0 0 .861-2.107v-9.818h10.824c0-3.065-1.102-5.652-3.257-7.711h.002Zm2.202 6.752H2.054c.239-2.538 1.34-4.694 3.257-6.37 1.916-1.675 4.262-2.49 6.992-2.49 2.73 0 5.077.814 7.04 2.49 1.916 1.677 2.97 3.832 3.21 6.37Z' />
);

export const viewBox = '0 0 25 25';
